import type { MeasurementSystem } from "../../shared/types";

const round = (value: number, digits = 1) => Number(value.toFixed(digits));

export const cmToInches = (value: number) => value / 2.54;
export const inchesToCm = (value: number) => value * 2.54;
export const kgToPounds = (value: number) => value * 2.20462;
export const poundsToKg = (value: number) => value / 2.20462;

export function formatMeasurement(valueCm: number, system: MeasurementSystem): string {
  return system === "EU" ? `${round(valueCm)} cm` : `${round(cmToInches(valueCm))} in`;
}

export function formatAdjustment(valueCm: number, system: MeasurementSystem): string {
  const converted = system === "EU" ? round(valueCm) : round(cmToInches(valueCm));
  const unit = system === "EU" ? "cm" : "in";
  return `${converted > 0 ? "+" : ""}${converted} ${unit}`;
}
